module.exports = __webpack_public_path__ + "img/brands-p-800.10c35b16.png";